import { dialogs, i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import React from 'react';

const { Paragraph } = designSystem;
const showUnsupportedBrowserDialog = () => {
  const description = i18next.t(
    'This function is not supported by your browser. To copy and paste images, please install the latest <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a> browser'
  );

  dialogs.operations.show(dialogTypes.ALERT_DIALOG, {
    glyph: 'alert-circle',
    width: 384,
    captions: {
      title: i18next.t('Unsupported Browser'),
      dismiss: i18next.t('Got it'),
    },
    content: (
      <React.Fragment>
        <Paragraph align="center" appearance="medium-emphasis">
          <span
            // eslint-disable-next-line yola/react/no-danger
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </Paragraph>
      </React.Fragment>
    ),
    onDismiss() {
      dialogs.operations.hide();
    },
  });
};

export default showUnsupportedBrowserDialog;
